import { format } from 'date-fns';
import { z } from 'zod';

export const searchSchema = z.object({
  ngay_ct1: z.string().optional(),
  ngay_ct2: z.string().optional(),
  ma_ngv: z.string().optional(),
  ma_gd: z.string().optional(),
  so_ct1: z.string().optional(),
  so_ct2: z.string().optional(),
  ma_kh: z.string().optional(),
  ma_nvbh: z.string().optional(),
  dien_giai: z.string().optional(),
  status: z.string().optional(),
  ma_unit: z.string().optional(),
  user_id0: z.string().optional()
});

export type SearchFormValues = z.infer<typeof searchSchema>;

export const initialSearchValues: SearchFormValues = {
  ngay_ct1: '',
  ngay_ct2: '',
  so_ct1: '',
  so_ct2: '',
  ma_ngv: '',
  ma_gd: '',
  ma_kh: '',
  ma_nvbh: '',
  dien_giai: '',
  status: '',
  ma_unit: '',
  user_id0: ''
};

export const formSchema = z.object({
  ma_ngv: z.string().optional(),
  ten_kh: z.string().optional(),
  dia_chi: z.string().optional(),
  ma_so_thue: z.string().optional(),
  ong_ba: z.string().optional(),
  e_mail: z.string().optional(),
  dien_giai: z.string().optional(),
  ngay_hl: z.string().optional(),
  so_ct: z.string().optional(),
  ngay_ct: z.string().optional(),
  ma_gd: z.string().optional(),
  ngay_lct: z.string().optional(),
  ma_nt: z.string().optional(),
  ty_gia: z.coerce.number().optional(),
  t_khoi_luong: z.coerce.number().optional(),
  status: z.string().optional()
});

export type FormSchema = z.infer<typeof formSchema>;

export const initialFormValues: FormSchema = {
  ma_ngv: '5',
  ten_kh: '',
  dia_chi: '',
  ma_so_thue: '',
  ong_ba: '',
  e_mail: '',
  dien_giai: '',
  ngay_hl: format(new Date(), 'yyyy-MM-dd'),
  so_ct: '',
  ngay_ct: format(new Date(), 'yyyy-MM-dd'),
  ngay_lct: format(new Date(), 'yyyy-MM-dd'),
  ma_nt: '',
  ty_gia: 1,
  t_khoi_luong: 0,
  status: '0'
};
